export default {
    EM_ELABORACAO: 'Em Elaboração',
    AGUARDANDO_ANALISE: 'Aguardando Análise',
    AGUARDANDO_ENVIO: 'Aguardando Envio',
    AGUARDANDO_REENVIO: 'Aguardando Reenvio',
    REENVIADO: 'Documento Enviado',
    CREDENCIADO: 'Credenciado',
    NAO_CREDENCIADO: 'Não Credenciado',
    ANALISADO: 'Analisado',
    REENVIADO_TEMPORARIO: 'Arquivo Anexado',
    ENVIADO_TEMPORARIO: 'Arquivo Anexado',
}